<template>
	<section class="portal-action-card">
		<header class="action-card-header">
			<div class="action-card-title">
				<span class="action-card-icon" aria-hidden="true">
					<portal-icon :name="icon" :size="21"></portal-icon>
				</span>
				<div>
					<h3>{{ title }}</h3>
					<span class="action-card-count">{{ count }}</span>
				</div>
			</div>
			<button type="button" class="action-card-open" :aria-label="title" @click="$emit('open')">
				<portal-icon name="arrow-right" :size="19"></portal-icon>
			</button>
		</header>
		<div class="action-card-list">
			<slot></slot>
		</div>
	</section>
</template>

<script>
	export default {
		name: 'ActionCard',

		props: {
			title: { type: String, required: true },
			icon: { type: String, required: true },
			count: { type: Number, required: true },
		},
	};
</script>

<style lang="scss">
	.portal-action-row {
		width: 100%;
		min-height: 58px;
		display: flex;
		align-items: center;
		gap: 12px;
		padding: 12px 16px;
		border: 0;
		border-bottom: 1px solid var(--portal-border);
		background: transparent;
		color: var(--portal-text);
		cursor: pointer;
		text-align: left;
	}

	.portal-action-row:last-child {
		border-bottom: 0;
	}

	.portal-action-row:hover {
		background: var(--v-gray_10-base);
	}

	.portal-action-row:focus-visible {
		position: relative;
		outline: 2px solid var(--v-primary-base);
		outline-offset: -3px;
	}

	.portal-action-row > .portal-icon {
		flex: 0 0 auto;
		color: var(--portal-muted);
	}

	.action-row-copy {
		min-width: 0;
		flex: 1;
		display: grid;
		gap: 3px;
	}

	.action-row-copy strong,
	.action-row-copy small {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.action-row-copy strong {
		color: var(--portal-text);
		font-size: 14px;
		font-weight: 500;
		line-height: 1.35;
	}

	.action-row-copy small {
		color: var(--portal-muted);
		font-size: 12px;
		line-height: 1.4;
	}
</style>

<style scoped lang="scss">
	.portal-action-card {
		overflow: hidden;
		border: 1px solid var(--portal-border);
		border-radius: var(--portal-radius-md);
		background: var(--portal-surface);
		box-shadow: 0 1px 2px rgba(16, 17, 15, 0.04);
	}

	.action-card-header,
	.action-card-title,
	.action-card-title > div {
		display: flex;
		align-items: center;
	}

	.action-card-header {
		justify-content: space-between;
		gap: 12px;
		padding: 16px 16px 13px;
		border-bottom: 1px solid var(--portal-border);
	}

	.action-card-title {
		min-width: 0;
		gap: 11px;
	}

	.action-card-title > div {
		min-width: 0;
		gap: 8px;
	}

	.action-card-title h3 {
		overflow: hidden;
		margin: 0;
		color: var(--portal-text);
		font-size: 16px;
		font-weight: 600;
		line-height: 1.3;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.action-card-icon {
		width: 36px;
		height: 36px;
		flex: 0 0 36px;
		display: grid;
		place-items: center;
		border-radius: 11px;
		background: var(--v-blue_5-base);
		color: var(--v-primary-base);
	}

	.action-card-icon .portal-icon {
		color: currentColor;
	}

	.action-card-count {
		min-width: 24px;
		height: 24px;
		display: grid;
		place-items: center;
		padding: 0 7px;
		border-radius: 99px;
		background: var(--v-gray_20-base);
		color: var(--portal-muted);
		font-size: 12px;
		font-weight: 600;
	}

	.action-card-open {
		width: 34px;
		height: 34px;
		flex: 0 0 34px;
		display: grid;
		place-items: center;
		border: 0;
		border-radius: var(--brand-button-radius, 10px);
		background: transparent;
		color: var(--portal-muted);
		cursor: pointer;
	}

	.action-card-open:hover {
		background: var(--v-gray_20-base);
		color: var(--portal-text);
	}

	.action-card-open:focus-visible {
		outline: 2px solid var(--v-primary-base);
		outline-offset: 2px;
	}

	.action-card-list {
		display: grid;
	}
</style>
